import { RouterName } from '@/enums/router-name'
import { useOtpStore } from '@/stores/use-otp-store'
import { useStorage } from '~library/composables'
import { LocalStorage } from '~library/enums'
import { useRouterUtils } from './use-router-utils'

/**
 * 多分頁登入狀態同步：監聽 localStorage 變更事件，
 * 當其他分頁登出或切換帳號時自動 reload 保持一致。
 * 企業會員綁定頁面除外（綁定流程中不應強制 reload）。
 */
export function useReload() {
  const { getStorageKey } = useStorage()
  const { routerName } = useRouterUtils()
  const { defaultOtpData } = useOtpStore()

  const isBindingPage = computed(() => {
    return [
      RouterName.COMPANY_EMPLOYEE,
      RouterName.COMPANY_EMPLOYEE_BIND,
      RouterName.COMPANY_EMPLOYEE_BIND_CHANGE,
      RouterName.COMPANY_EMPLOYEE_BIND_SUCCESS
    ].includes(routerName.value)
  })

  const storageListenerReload = () => {
    addEventListener('storage', (event) => {
      if (isBindingPage.value) {
        return
      }

      if (
        event.key === getStorageKey(LocalStorage.USER_PROFILE) ||
        event.key === getStorageKey(LocalStorage.USER_PROFILE_IDENTITY)
      ) {
        defaultOtpData()
        window.location.reload()
      }
    })
  }

  return {
    /** 註冊 localStorage 變更監聽，其他分頁登出時自動 reload */
    storageListenerReload
  }
}
